import { ALLOWED_AUTH_SERVICES } from '../constants/authPermissions';

interface JwtUserPayload {
  scope?: string;
}

interface JwtPayload {
  user?: JwtUserPayload;
  scope?: string;
}

/**
 * Decodifica o payload de um JWT sem validar assinatura.
 */
function decodeJwtPayload(token: string): JwtPayload | null {
  if (!token) {
    return null;
  }

  try {
    const parts = token.split('.');
    if (parts.length !== 3) {
      return null;
    }

    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
    const decoded = atob(padded);
    return JSON.parse(decoded) as JwtPayload;
  } catch {
    return null;
  }
}

/**
 * Extrai o scope do usuário a partir do access_token.
 */
export function getScopeFromToken(token: string): string {
  const payload = decodeJwtPayload(token);

  if (!payload) {
    return '';
  }

  if (typeof payload.user?.scope === 'string') {
    return payload.user.scope;
  }

  if (typeof payload.scope === 'string') {
    return payload.scope;
  }

  return '';
}

/**
 * Verifica se o scope contém permissão em codilo-admin ou codilo-staff.
 */
export function hasAllowedServiceScope(scope: string): boolean {
  if (!scope) {
    return false;
  }

  return ALLOWED_AUTH_SERVICES.some((service) => scope.includes(`${service}:`));
}

/**
 * Valida se o token concede acesso ao SupReq.
 */
export function hasSupreqAccess(token: string): boolean {
  return hasAllowedServiceScope(getScopeFromToken(token));
}
